export default "__VITE_ASSET__DocWT9Q9__"